'use strict';

import controller from './autoridad-beneficiaria.controller';
import template from './autoridad-beneficiaria.html';

const AutoridadBeneficiariaComponent = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default AutoridadBeneficiariaComponent;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/autoridad-beneficiaria/autoridad-beneficiaria.component.js